(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './defaultTraveler', './attachComments'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./defaultTraveler'), require('./attachComments'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defaultTraveler, global.attachComments);
    global.astravel = mod.exports;
  }
})(this, function (exports, _defaultTraveler, _attachComments) {
  'use strict';

  exports.__esModule = true;
  exports.makeTraveler = exports.attachComments = exports.defaultTraveler = undefined;

  var _defaultTraveler2 = _interopRequireDefault(_defaultTraveler);

  var _attachComments2 = _interopRequireDefault(_attachComments);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  // Astravel is  tiny and fast ESTree-compliant AST walker and modifier.
  //
  // Astravel was written by David Bonnet and released under an MIT license.
  //
  // The Git repository for Astravel is available at:
  // https://github.com/davidbonnet/astravel.git
  //
  // Please use the GitHub bug tracker to report issues:
  // https://github.com/davidbonnet/astravel/issues

  function makeTraveler(properties) {
    /*
    Returns a custom AST traveler that inherits from the `defaultTraveler` with its own provided `properties` and the property `super` that points to the parent traveler object.
    */
    return _defaultTraveler2.default.makeChild(properties);
  }

  exports.defaultTraveler = _defaultTraveler2.default;
  exports.attachComments = _attachComments2.default;
  exports.makeTraveler = makeTraveler;
});
//# sourceMappingURL=astravel.js.map